import { BlocksRenderer } from '@strapi/blocks-react-renderer';
import useFetch from '../useFetch';
import { useParams, Link } from 'react-router-dom';

// === Components
import SingleImage from '../components/SingleImage';
import Text from '../components/Text';
import Video from '../components/Video';
import Gallery from '../components/Gallery';

function ProjectView() {
  const { id } = useParams();
  const { isLoading, error, data } = useFetch(
    `/api/projects?filters[slug][$eq]=${id}&populate[Components][populate]=*&populate[Button]=*`
  );

  let project = null;
  let sections = null;
  let display = [];

  if (data) {
    project = data.data[0].attributes;
    sections = data.data[0].attributes.Components;
    
    console.log('Project data:', project);
    console.log('Button data:', project.Button);

    for (let i = 0; i < sections.length; i++) {
      if (sections[i].__component === 'project-components.single-image') {
        display.push(<SingleImage data={sections[i]} />);
      } else if (sections[i].__component === 'project-components.text') {
        display.push(<Text data={sections[i]} />);
      } else if (sections[i].__component === 'project-components.video') {
        display.push(<Video data={sections[i]} />);
      } else if (sections[i].__component === 'project-components.gallery') {
        display.push(<Gallery data={sections[i]} />);
      }
    }

    return (
      <div className="min-height">
        <div className="page-wrapper">
          <div className="main-container project-view">
            <BlocksRenderer content={project.Title} />
            <h5> {project.Location} </h5>
          </div>
        </div>
        <div className="page-wrapper">
          <div className="main-container">
            <BlocksRenderer content={project.Description} />
          </div>
          <div className="side-container credits">
            {project.Credits ? (
              <BlocksRenderer
                content={project.Credits}
                blocks={{
                  heading: ({ children, level }) => {
                    switch (level) {
                      case 4:
                        return <h4 className="credit-title">{children}</h4>;
                    }
                  },
                }}
              />
            ) : null}
          </div>
        </div>
        <div>
          {display.map((section, index) => (
            <div key={index}>{section}</div>
          ))}
        </div>
        {project.Button && project.Button.Toggle && (
          <div className="project-cta-container">
            {project.Button.Button_Link ? (
              project.Button.Button_Link.startsWith('http') ? (
                <a href={project.Button.Button_Link} target="_blank" rel="noopener noreferrer">
                  <button className="project-cta-button">
                    <BlocksRenderer content={project.Button.Button_Text} />
                  </button>
                </a>
              ) : (
                <Link to={project.Button.Button_Link}>
                  <button className="project-cta-button">
                    <BlocksRenderer content={project.Button.Button_Text} />
                  </button>
                </Link>
              )
            ) : (
              <button className="project-cta-button">
                <BlocksRenderer content={project.Button.Button_Text} />
              </button>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default ProjectView;
